/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Attachment } from './Attachment';
import type { ConversationChannel } from './ConversationChannel';
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { MessageDirection } from './MessageDirection';
import type { MessageError } from './MessageError';
import type { MessageMediaProcessing } from './MessageMediaProcessing';
import type { MessageParticipantInfo } from './MessageParticipantInfo';
import type { MessageStatus } from './MessageStatus';
/**
 * Interface representing a message document
 */
export type MessageDocument = {
    id: string;
    metadata?: Dictionary_unknown_;
    tenantId: string;
    content: string;
    userId?: string;
    status: MessageStatus;
    providerId: string;
    direction: MessageDirection;
    conversationId: string;
    channel: ConversationChannel;
    sender: MessageParticipantInfo;
    recipient?: MessageParticipantInfo;
    attachments?: Array<Attachment>;
    errors?: Array<MessageError>;
    customFields?: Dictionary_unknown_;
    mediaProcessing?: MessageMediaProcessing;
    modelType: MessageDocument.modelType;
    createdAt: string;
    updatedAt: string;
    archivedAt?: string | null;
    eventSequence?: number;
    eventTimestamp?: string;
    funnelId?: string;
    funnelConversationId?: string;
    contactId?: string;
    sessionId?: string;
};
export namespace MessageDocument {
    export enum modelType {
        MESSAGE = 'Message',
    }
}

